import { HSComponent } from './component.js';
import { HelpRegistry } from './help-registry.js';
import './help-modal.js';
import styles from './help-icon.css';
import template from './help-icon.html';

// Reusable inline help trigger — <hs-help-icon key="wizard.step1.symptom_selection">.
// Hidden entirely when the key has no registry entry (absent key = no hint
// available, not an error). Hover shows `short` via the native title attribute;
// click opens <hs-help-modal> with `long` only when `long` is present.
// See docs/PIPELINE_SANDBOX_HELP_SYSTEM.md.
export class HSHelpIcon extends HSComponent {
    #key = null;

    static get observedAttributes() { return ['key']; }

    async onLoad() {
        this.loadTemplate(template);
        this.loadStyles(styles);
        this.#key = this.getAttribute('key');
        // stopPropagation/preventDefault: icons often sit inside a <label> (e.g.
        // wrapping a checkbox) — without this, clicking the icon would also
        // toggle whatever control the label is for.
        this.onEvent('click', (_, ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            this.#openModal();
        }, this.shadowRoot.querySelector('.hi-btn'));
        await HelpRegistry.ensureLoaded();
        this.#render();
    }

    attributeChangedCallback(name, _old, value) {
        if (name !== 'key' || this.#key === value) return;
        this.#key = value;
        if (this.shadowRoot?.querySelector('.hi-btn')) this.#render();
    }

    #render() {
        const btn = this.shadowRoot.querySelector('.hi-btn');
        if (!btn) return;
        const entry = HelpRegistry.getEntry(this.#key);
        if (!entry) {
            this.classList.add('hidden');
            return;
        }
        this.classList.remove('hidden');
        btn.title = entry.short || '';
        btn.classList.toggle('hi-clickable', !!entry.long);
    }

    #openModal() {
        const entry = HelpRegistry.getEntry(this.#key);
        if (!entry?.long) return;
        const root = this.getRootNode();
        let modal = root.querySelector?.('hs-help-modal');
        if (!modal) {
            modal = document.createElement('hs-help-modal');
            root.appendChild(modal);
        }
        modal.open({ key: this.#key, entry });
    }
}

customElements.define('hs-help-icon', HSHelpIcon);
